module.exports = __webpack_public_path__ + "static/img/StackedLine.702d5ded.png";